
import api from "../Api";
import { BaseService } from "../BaseService";

const URL = 'chats';

export class ChatsService extends BaseService {
    async me(params: any, query?: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/me`, params, query ? { params: query } : undefined));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async list(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async send(params: any, signal?: AbortSignal): Promise<any> {
        try {
            return this.handleResponse(await api.post(`${URL}/send`, params, { signal }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async sendWithFiles(formData: FormData, signal?: AbortSignal): Promise<any> {
        try {
            return this.handleResponse(await api.post(`${URL}/send`, formData, { signal }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    // AI-940: cancela a geração em andamento (por generation_id). Best-effort.
    async cancel(generationId: string): Promise<any> {
        try {
            return this.handleResponse(await api.post(`${URL}/cancel`, { generation_id: generationId }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async vote(messageId: number, vote: boolean): Promise<any> {
        try {
            return this.handleResponse(await api.post(`${URL}/messages/${messageId}/vote`, { vote }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async finish(chatId: number): Promise<any> {
        try {
            return this.handleResponse(await api.get(`${URL}/close/${chatId}`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async getAssistants(): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(`${URL}/assistants/list`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}